export default {
  items: [
    {
      link: "/",
      resource: "",
      text: "Home",
      icon: "home"
    },
    {
      link: "/user/profile",
      resource: "users",
      text: "Profile",
      icon: "user"
    },
    {
      link: "/support",
      resource: "",
      text: "Support",
      icon: "question-circle",
      class: "is-info"
    },
    {
      link: "/auth?signout=1",
      resource: "",
      text: "Sign Out",
      icon: "sign-out-alt",
      class: "is-danger"
    }
  ],
  header: {
    title: "User Menu",
    show: true
  },
  hidden: true
}